import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FileOpener } from '@awesome-cordova-plugins/file-opener/ngx';
import { File } from '@awesome-cordova-plugins/file/ngx';
import {
  AlertController,
  ModalController,
  Platform,
  ToastController
} from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import * as FileSaver from 'file-saver';
import { StudenteEnanche } from '../models/didattica/studente-enanche';
import { Libretto } from '../models/idoneita/libretto';
import { Presenza } from '../models/rilevazione-presenze/presenza';
import { PlatformName } from '../services/env-service/env-platform';
import { EventsService } from './eventsService';
import { addMinutes } from 'date-fns';
import { Rilevazione } from '../models/rilevazione-presenze/rilevazione';
import { OreTipoAttivita } from '../models/didattica/ore-tipo-attivita';
import { ConfigService } from './config-service/config-service';


@Injectable({
  providedIn: 'root'
})
// servizi vari di utilità
export class UtilityService {

  sortProp = 'cognome'; // ordinamento di default
  sortAscDesc = 'asc';
  nestedObject: string;
  iconOrdinamento;
  filtroAttivo = '';

  constructor(
    private translateService: TranslateService,
    private readonly toastCtrl: ToastController,
    private file: File,
    private fileOpener: FileOpener,
    private modalCtrl: ModalController,
    private alertCtrl: AlertController,
    private events: EventsService,
    private configService: ConfigService,
    private platform: Platform,
  ) { }

  async presentAlertConfirm(message: string , title: string, actionKeepChanges, actionCancel?) {
    if (!actionCancel) {
      actionCancel = () => { alert.dismiss(); };
    }
    const alert = await this.alertCtrl.create({
      header: title,
      message: message,
      buttons: [
        {
          text: this.translateService.instant('label.cancel'),
          role: 'cancel',
          handler: actionCancel
        }, {
          text: this.translateService.instant('label.keepchanges'),
          handler: actionKeepChanges
        }
      ]
    });

    await alert.present();
  }

  async presentAlertConfirmCancel(message: string , title: string, actionConfirm, actionCancel?) {
    if (!actionCancel) {
      actionCancel = () => { alert.dismiss(); };
    }
    const alert = await this.alertCtrl.create({
      header: title,
      message: message,
      buttons: [
        {
          text: this.translateService.instant('label.cancel'),
          role: 'cancel',
          handler: actionCancel
        }, {
          text: this.translateService.instant('label.confirm'),
          handler: actionConfirm
        }
      ]
    });

    await alert.present();
  }

  async presentSimpleAlert( message: string , title: string, actionConfirm, textButtonPopup?: string) {
    const alert = await this.alertCtrl.create({
     header: title,
     message: message,
     buttons: [
      {
        text: textButtonPopup ? textButtonPopup : this.translateService.instant('label.confirm'),
        handler: actionConfirm
      }
    ],
    backdropDismiss: false
 });
   await alert.present();
 }

 showAlertAndLogout(message: string, textButtonPopup?: string) {
  const title = this.translateService.instant('label.warning');
  this.presentSimpleAlert(message, title, () => {
    this.events.logout.next();
  }, textButtonPopup);
}

  ///// metodi di gestione degli array

  getArrayMinByProp(array: any[], prop: string) {
    return array.reduce((min, p) =>
              p[prop] < min ? p[prop] : min, array[0][prop]);
  }
  getArrayMaxByProp(array: any[], prop: string) {
    return array.reduce((max, p) =>
              p[prop] > max ? p[prop] : max, array[0][prop]);
  }

  orderBy(data: any, arr: any) {
    if (!arr) {
      return;
    }
    // console.log('orderBy', data);
    // console.log('array', arr);
    this.nestedObject = '';
    this.sortProp = data.field;
    this.iconOrdinamento = data.ascdesc;
    this.filtroAttivo = data.field;
    if (data.field.indexOf('.') > 0 ) { // frequenza e assenza si trovano all'interno dell'elemento freqinfo
      this.nestedObject = data.field.split('.')[0] ; // 'freqinfo';
      this.sortProp = data.field.split('.')[1];
    }
    this.sort(this.nestedObject, this.sortProp , arr, data.ascdesc);
  }


  // funzione di ordinamento del json in base ad una proprietà
  // dell'oggetto contenuto nell'array
  // nel caso in cui nestedObj sia
  // vuoto ordina in base a proprietà dell'elemento base dell'array
  sort (nestedObj, prop, arr, order = 'asc') {
    if (nestedObj === '') {
      this.simpleSort ( prop, arr, order) ;
    } else {
      let comparison;
      arr.sort((a, b) => {
          if (a[nestedObj][prop] < b[nestedObj][prop]) {
              comparison = -1;
          } else if (a[nestedObj][prop] > b[nestedObj][prop]) {
              comparison = 1;
          } else {
              comparison = 0;
          }
          return (order === 'desc') ? (comparison * -1) : comparison ;
      });
    }
 }

 simpleSort (prop, arr: Presenza[], order) {
  let comparison;
  arr.sort((a, b) => {
      if (a[prop] < b[prop]) {
          comparison = -1;
      } else if (a[prop] > b[prop]) {
          comparison = 1;
      } else {
          comparison = 0;
      }
      return (order === 'desc') ? (comparison * -1) : comparison ;
  });
}
  // compareValues(key, order = 'asc') {
  //   return function innerSort(a, b) {
  //     if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) { return 0; }
  //     const comparison = a[key].localeCompare(b[key]);
  //     return (
  //       (order === 'desc') ? (comparison * -1) : comparison
  //     );
  //   };
  // }

  ///// metodi di gestione degli hint

  async presentToast(mess: string) {
    const toast = await this.toastCtrl.create({
      message: mess,
      duration: 3000,
      // showCloseButton: true,
      // closeButtonText: 'X'
    });
    await toast.present();
  }

  async showHint(mess1: string, mess2: string = null) {
    let message = this.translateService.instant( mess1 );
    if (mess2) {
      message = message + mess2;
    }
    await this.showHintNoTranslate(message);
  }

  public showDocSearchInfo() {
    const n = Number(this.configService.minDocSearchChars) + 1;
    this.showHintNoTranslate(this.translateService.instant('report.label.mindocsearchchars' , {n: n}));
  }

  async showHintNoTranslate(message: string) {
    await this.presentToast(message);
  }

  async showHintNoProp(mess, mess2: string = null, event: Event = null) {
    // console.log('event', event);
    await this.showHint(mess, mess2);
    if (event) {
      await event.stopPropagation();
    }
  }


  async showModal(component: any, componentProps: any = {}, _cssClass: any = 'defModClass', backdrop?: boolean): Promise<any> {
    const dialog = await this.modalCtrl.create({
      component,
      cssClass: _cssClass,
      componentProps,
      backdropDismiss: backdrop
    });
    await dialog.present();
    return await dialog.onDidDismiss();
  }


  // metodi di gestione dei pdf

  downloadFile(data: any, prefix: string, type: string, ext: string) {
    if (data) {
      const blob = new Blob([data], { type: type });
      const fileName = this.generaFilename(prefix, ext);
      if (this.platform.is(PlatformName)) { // ex cordova
        this.showPdf(blob, fileName);
      } else {
        FileSaver.saveAs(blob, fileName);
        console.log('file saver ha completato il download', blob.size);
      }

    } else {
      console.log(
        'Esportazione lato server non riuscita: ' +
          data.status +
          '-' +
          data.statusText
      );
    }
    // this.esportazioneInCorso = false;
  }

  showPdf(blob: any, fileName: string) {
    console.log('this.file.dataDirectory', this.file.dataDirectory );
    console.log('fileName', fileName);
    this.file.writeFile(this.file.dataDirectory, fileName, blob, {replace: true})
    .then((success) => {
      console.log('File created Succesfully' + JSON.stringify(success));
      this.fileOpener.open(this.file.dataDirectory + fileName, 'application/pdf')
        .then(() => console.log('File is opened'))
        .catch(e => console.log('Error opening file', e));
    })
    .catch((error) => {
      console.log('Cannot Create File ' + JSON.stringify(error));
    });

    // return this.file.writeFile(this.file.dataDirectory, 'hello.json', JSON.stringify({test: 'value'}), {replace: true});
  }

  generaFilename(prefix: string, ext: string) {
    const now = new Date();
    prefix = prefix.replace(':', '_'); // per ora sistemiamo così il problema generato dal : nel mome del file
    return `${prefix}_${now.getFullYear()}_${now.getMonth() + 1}_${now.getDate()}_${now.getHours()}_${now.getMinutes()}.${ext}`;
  }


  // metodi di gestione delle date

   // la formattazione intervallo |date | "hh:mm:ss" non da risultati corretti per via del time zone
   formatDate(value: number): string {
    const hours: number = Math.floor(value / ( 60 * 60));
    let minutes: number = Math.floor(value / 60);
    const seconds: number = Math.floor((value - minutes * 60));
    // console.log('hours', hours);
    // console.log('minutes', minutes);
    // console.log('seconds', seconds);
      let ret = '';
    // meno di un'ora
    if (hours < 1) {
      if (minutes < 1) {
        // meno di un minuto, visualizzerà i secondi che scorrono
        ret = seconds.toString().padStart(2, '0') + ' sec.';
      } else {
        // meno di un'ora e più di 1 minuto,
        ret = minutes.toString().padStart(2, '0') + ' min.';
      }
    } else {
      // più di 1 ora
      minutes = minutes - hours * 60;
      ret = hours.toString().padStart(2, '0') + ':' +
              minutes.toString().padStart(2, '0') ;
    }
    return ret;
 }

 formatDurata(minuti: number): string {

  // console.log('durata', durata);
  // set minutes to seconds
  let seconds = minuti * 60;

  // calculate (and subtract) whole days
  const days = Math.floor(seconds / 86400);
  seconds -= days * 86400;

  // calculate (and subtract) whole hours
  let hours = Math.floor(seconds / 3600) % 24;
  seconds -= hours * 3600;

  // calculate (and subtract) whole minutes
  const minutes = Math.floor(seconds / 60) % 60;
  let ret = '';
  if (days > 0) {
    // ret = days + 'd ';
    hours += 24 * days;
  }
  ret += (hours + '').padStart(2, '0') + ':' + (minutes + '').padStart(2, '0');
  return ret;
}

setLocalTime(dateString) {
  return addMinutes(new Date(dateString), -(new Date(dateString).getTimezoneOffset()));
}

setUTCTime(dateString) {
  return addMinutes(new Date(dateString), new Date(dateString).getTimezoneOffset());
}

 async showError(error: any) {
  // this.utilityService.showHintNoTranslate(message);
  await this.showHintNoTranslate(this.extractErrorMsg(error));
 }


  extractErrorMsg(error: any) {
    let message: string;
      if (error instanceof HttpErrorResponse) {
        if (error.error.code === 'XR07') {
          message = this.getExtendedMessage(error.error);
        } else {
          message = this.getMessage(error.error);
        }
        console.log('HttpErrorResponse', message);
      } else {
        message = JSON.parse(error._body).message;
        console.log('NO HttpErrorResponse', message);
      }
      if (message.startsWith('rilfreq.')) {
        return this.translateService.instant(`error.${ message || 'operation'}.template`);
      } else {
        if (message.endsWith("}]")) {
          message = this.semplifyErrorMessage(message);
        }
        return message;
    }
  }

  getMessage(err) {
    let message;
    try {
      message = JSON.parse(err).message;
    } catch (e) {
      message = err.message;
    }
    return message;
  }

  getExtendedMessage(err) {
    let message;
    try {
      message = JSON.parse(err).extendedMessage;
    } catch (e) {
      message = err.extendedMessage;
    }
    return message;
  }


  addInfoLibretto(classe: Libretto[], stud: StudenteEnanche, oreAr: number, ricalcolaFrequenza: boolean): any {
    // se sul libretto dello studente sono presenti le ore necessarie perché risulti frequentato,
    // va ricalcolata la frequenza utilizzando questa informazione e non le ore complessive sulla ar

    // ha senso solo nel caso in cui sia prevista un'erogazione completa delle
    // attività prima di accedere all'invio delle idoneità NO NO NO,
    // lo abbiamo aperoto a tutti i casi in cui la durata sul libretto sia diversa da quella dell'ad
    // const percMinInvioIdoneita = this.configService.getConfigurazione(ChiaveConfig.PERC_MIN_INVIO_IDONEITA) * 1;
    // const inviaIdoneitaSoloSeErogCompleta = percMinInvioIdoneita === 100;
    // console.log('ricalcolaFrequenza stud', stud);
    // if (inviaIdoneitaSoloSeErogCompleta && this.classe) {
    let freq = stud.freqinfo.frequenza;
    if (classe) {
      const lib = this.getStudenteClasse(classe, stud.studente.id);
      // console.log('ricalcolaFrequenza lib', lib);
      if (lib && lib.durata && lib.durata !== oreAr) {
        // const freq = stud.freqinfo.frequenza * this.attivitaReale.totaleMinuti / lib.durata;
        if (ricalcolaFrequenza) {
          freq = stud.freqinfo.totpres / (lib.durata * 60);
          // console.log('ricalcolaFrequenza orig/ricalc', stud.freqinfo.frequenza + '/' + freq);
        }
        stud.freqinfo.duratadalib = lib.durata;
        stud.freqinfo.oreMinFreq = lib.oreMinFreq;
        stud.freqinfo.libretto = true;
        return freq;
      }
    }
    return freq;
  }

  getStudenteClasse(classe: Libretto[], stu_id: any): Libretto {
    // tslint:disable-next-line:triple-equals
    const localStudenti = classe.filter((lib) =>  lib.stuId == stu_id);
    if (localStudenti.length === 1) {
      return localStudenti[0];
    }
    return undefined;
  }

  checkDates(sdate, edate, rilevazione: Rilevazione): string {
    let mess;
    let ret = false;
    if (sdate > edate) {
      mess = this.translateService.instant('manage-presenza.error.starttimeoverend');
      return mess;
    }

    if (sdate) {
      ret = this.dataInsideRil(new Date(sdate), rilevazione);
      if (!ret) {
        mess = this.translateService.instant('manage-presenza.error.starttime');
        return mess;
      }
    }
    if (edate) {
      ret = this.dataInsideRil(new Date(edate), rilevazione);
      if (!ret) {
        mess = this.translateService.instant('manage-presenza.error.endtime');
        return mess;
      }
    }
    return mess;
  }


  dataInsideRil(dt: Date, rilevazione: Rilevazione): boolean {
    console.log('dtToCheck', dt);
    console.log('ril start', new Date(rilevazione.istanteCreazione));
    console.log('ril   end', new Date(rilevazione.chiusura));

    if (new Date(rilevazione.istanteCreazione) <= dt
        &&
        new Date(rilevazione.chiusura) >= dt) {
      return true;
    }
    return false;
  }

  dataConfermaCoerente(dt: Date, rilevazione: Rilevazione): boolean {
    console.log('dtToCheck', dt);
    console.log('ril rich', new Date(rilevazione.richiestaConferma.istanteRichiesta));
    console.log('ril   end', new Date(rilevazione.chiusura));

    // andrebbe controllato che la data sia tra l'inizio della richiesta e la fine della richiesta stessa
    // ma non registriamo il valore della durata della richiesta. Farà fede la fine della ril
    if (new Date(rilevazione.richiestaConferma.istanteRichiesta) <= dt
        &&
        new Date(rilevazione.chiusura) >= dt) {
      return true;
    }
    return false;
  }

  private semplifyErrorMessage(message: string) {
    let indexText = message.indexOf('Msg":"') + 6;
    message = message.slice(indexText);
    indexText = message.indexOf('","');
    message = message.slice(0, indexText);
    return message;
  }

  getMinOreTipoAttivita(): OreTipoAttivita[] {
    let oreTipoAttivita: OreTipoAttivita[] = [];
    try {
      const minTipoAttivitaS = this.configService.minTipoAttivitaS;
      const minTipoAttivitaParsed = JSON.parse(minTipoAttivitaS);
      if (Array.isArray(minTipoAttivitaParsed)) {
        oreTipoAttivita = minTipoAttivitaParsed.map(
          (a: any) => ({
            cod: a.cod,
            ore: Number(a.perc_ore)
          })
        );
      }
    } catch (error) {
    }
    return oreTipoAttivita;
  }


  mergeSuddivisioni(
    a1: OreTipoAttivita[],
    a2: OreTipoAttivita[]
  ): OreTipoAttivita[] {

    const map = new Map<string, OreTipoAttivita>();

    [...a1, ...a2].forEach(item => {
      if (!map.has(item.cod)) {
        map.set(item.cod, { ...item });
      } else {
        const existing = map.get(item.cod)!;

        existing.ore += item.ore;
        existing.minErogati += item.minErogati;

        existing.oreF = this.formatDurata(existing.ore*60);
        existing.oreErogateF = this.formatDurata(existing.minErogati);

        existing.percErog = item.minErogati/(item.ore*60);

      }
    });

    return Array.from(map.values());
  }

  cloneSuddivisione(arr: OreTipoAttivita[]): OreTipoAttivita[] {
    return arr.map(item => ({
      cod: item.cod,
      desc: item.desc,
      ore: item.ore,
      minErogati: item.minErogati,
      minFruiti: 0,
      percErog: 0,
      percFruit: '0'
    }));
  }
  
  aggiornaSuddivisioni(arr: OreTipoAttivita[]) {
    return arr.map(item => ({
      cod: item.cod,
      desc: item.desc,
      ore: item.ore,
      minErogati: item.minErogati,
      minFruiti: item.minFruiti,
      percErog: item.minErogati/(item.ore*60),
      percFruit: item.minFruiti === 0? item.percFruit: item.minFruiti/(item.ore*60),
      percFruitSuErog: item.minFruiti === 0? item.percFruit: item.minFruiti/(item.minErogati),
      
      oreF: this.formatDurata(item.ore*60),
      oreErogateF: this.formatDurata(item.minErogati)
    }));

  }
}
